/** @prettier */

import {Box, Grid, IconButton} from '@mui/material';
import {useState} from 'react';

//MTH component import
import ScheduleActionControlContents from './ScheduleActionControlIconContents';
import ScheduleDeleteDialog from './ScheduleDeleteDialog';
import ScheduleSettingDialog from './ScheduleSettingDialog'; //interface import
import * as apiIF from '../../Type/api';

import {iconBlack, iconWhite} from '../../define';
import {useTranslation} from 'react-i18next';

/**
 * commandTimeの時間部分の0埋め表示を修正する
 * @param time スケジュール設定時間
 * @return 画面に表示する時間
 */
export const commandTimeSetting = (time: string) => {
  /** 時刻から、時間部分を取り出す
   * @param time 時間 (例 12:34)
   * @returns 時間 (例 12)
   */
  const getHour = (time: string) => {
    const colonPosition = time.indexOf(':');
    return time.slice(0, colonPosition);
  };

  /** 時刻から、分部分を取り出す
   * @param time 時間 (例 12:34)
   * @returns 時間 (例 34)
   */
  const getMinute = (time: string) => {
    const colonPosition = time.indexOf(':');
    return time.slice(colonPosition + 1);
  };

  //時間部分と分部分をそれぞれ取り出す
  let hour = getHour(time);
  let minute = getMinute(time);
  //0サプレスを行う
  const suppressZeroHour = parseFloat(hour);
  //設定時間を元の形に戻す
  const commandTime = `${suppressZeroHour}:${minute}`;
  return commandTime;
};

/**
 * スケジュール表示
 * @param props props
 * @returns JSX.Element
 */
export const ScheduleItem = (props: {
  /** 画面表示用スケジュールデータ */
  scheduleItemData: apiIF.reqParameters.schedule;
  /** グループID */
  groupID: string;
  /** 表示するスケジュールのindex番号 */
  index: number;
  /** スケジュール更新関数 */
  scheduleChangeHandler: () => void;
  /** 選択スケジュール行 */
  selectedRow: number | string;
  /** 選択スケジュール行設定関数 */
  setSelectedRow: React.Dispatch<React.SetStateAction<number | string>>;
  /** 当日スケジュールBodyデータ（当日スケジュールの場合のみ） */
  todayScheduleData?: apiIF.res.getTodaySchedule['today-schedule'];
  /** 特定日の種類（特定日スケジュールの場合のみ） */
  type?: keyof apiIF.res.getDailySchedule;
  /** 特定日スケジュールのBodyデータ（特定日スケジュールの場合のみ） */
  dailyScheduleRequestData?: apiIF.reqParameters.patchDailySchedule;
  /** 特定日スケジュールのresponseデータ（特定日スケジュールの場合のみ） */
  dailyScheduleData?: apiIF.res.getDailySchedule;
}) => {
  const trans = useTranslation().t; //翻訳関数

  const [isOpenEditDialog, setIsOpenEditDialog] = useState(false); //編集ダイアログ表示フラグ
  const [isOpenDeleteDialog, setIsOpenDeleteDialog] = useState(false); //削除ダイアログ表示フラグ

  /**
   * スケジュール行が選択状態か判定
   * @param row 行
   */
  const selectHandle = (row: number) => {
    //ダイアログが開いている場合は処理を行わない
    if (isOpenEditDialog === true || isOpenDeleteDialog === true) {
      return;
    } else if (row === props.selectedRow) {
      props.setSelectedRow('');
    } else {
      props.setSelectedRow(row);
    }
  };

  /**
   * Editボタン押下時処理
   * @param priorityLevel ロジックの優先レベル
   */
  const openEditDialog = () => {
    setIsOpenEditDialog(true);
  };

  /**
   * Deleteボタン押下時処理
   * @param priorityLevel ロジックの優先レベル
   */
  const openDeleteDialog = () => {
    setIsOpenDeleteDialog(true);
  };

  return (
    <Grid
      container
      alignItems="center"
      onClick={e => {
        selectHandle(props.index);
      }}
      className={`schedule__table__body__row ${
        props.index === props.selectedRow
          ? 'schedule__table__body__row--selected'
          : ''
      }`}>
      {/** 時刻 */}
      <Grid item xs={2.5} className="schedule__table__body__row__item">
        {commandTimeSetting(props.scheduleItemData['command-time'])}
      </Grid>
      {/** 指令値 */}
      <Grid item xs={4.5} className="schedule__table__body__row__item">
        <ScheduleActionControlContents scheduleInfo={props.scheduleItemData} />
      </Grid>
      {/** 操作アイコン */}
      <Grid item xs className="schedule__table__body__row__item">
        <Grid container columnSpacing={2}>
          <Grid
            item
            xs="auto"
            className="schedule__table__body__row__item__operationIcon">
            <IconButton
              size="small"
              onClick={e => {
                e.stopPropagation();
                openEditDialog();
              }}>
              <Box className="schedule__table__body__row__item__operationIcon__border">
                <img
                  title={`${trans(
                    `ScheduleItem.image.alternativeTxt.${iconWhite.EDIT.title}`
                  )}`}
                  src={iconBlack.EDIT.src}
                  alt={`${trans(
                    `ScheduleItem.image.alternativeTxt.${iconBlack.EDIT.alt}`
                  )}`}
                  className="schedule__table__body__row__item__operationIcon__border__image"
                />
              </Box>
            </IconButton>
          </Grid>
          <Grid
            item
            xs="auto"
            className="schedule__table__body__row__item__operationIcon">
            <IconButton
              size="small"
              onClick={e => {
                e.stopPropagation();
                openDeleteDialog();
              }}>
              <Box className="schedule__table__body__row__item__operationIcon__border">
                <img
                  title={`${trans(
                    `ScheduleItem.image.alternativeTxt.${iconWhite.DELETE.title}`
                  )}`}
                  src={iconBlack.DELETE.src}
                  alt={`${trans(
                    `ScheduleItem.image.alternativeTxt.${iconBlack.DELETE.alt}`
                  )}`}
                  className="schedule__table__body__row__item__operationIcon__border__image"
                />
              </Box>
            </IconButton>
          </Grid>
        </Grid>
      </Grid>
      {props.todayScheduleData !== undefined ? (
        <>
          <ScheduleSettingDialog
            targetGroupID={props.groupID}
            schedule={props.scheduleItemData}
            isOpenDialog={isOpenEditDialog}
            setIsOpenDialog={setIsOpenEditDialog}
            scheduleChangeHandler={props.scheduleChangeHandler}
            scheduleIndex={props.index}
            allTodaySchedule={props.todayScheduleData}
          />
          <ScheduleDeleteDialog
            targetGroupID={props.groupID}
            scheduleIndex={props.index}
            isOpenDialog={isOpenDeleteDialog}
            setIsOpenDialog={setIsOpenDeleteDialog}
            scheduleChangeHandler={props.scheduleChangeHandler}
            todayScheduleData={props.todayScheduleData}
          />
        </>
      ) : (
        <>
          <ScheduleSettingDialog
            targetGroupID={props.groupID}
            schedule={props.scheduleItemData}
            isOpenDialog={isOpenEditDialog}
            setIsOpenDialog={setIsOpenEditDialog}
            scheduleChangeHandler={props.scheduleChangeHandler}
            scheduleIndex={props.index}
            specificDayType={props.type}
            allDailySchedule={props.dailyScheduleData}
          />
          <ScheduleDeleteDialog
            targetGroupID={props.groupID}
            scheduleIndex={props.index}
            isOpenDialog={isOpenDeleteDialog}
            setIsOpenDialog={setIsOpenDeleteDialog}
            scheduleChangeHandler={props.scheduleChangeHandler}
            type={props.type}
            dailyScheduleData={props.dailyScheduleData}
          />
        </>
      )}
    </Grid>
  );
};
